export const blockIconsNotificationDoNotDisturbOn = (
	<span className='material-symbols-outlined'>do_not_disturb_on</span>
);
